import { render, staticRenderFns } from "./standardNumber.vue?vue&type=template&id=fd8a816a&scoped=true"
import script from "./standardNumber.vue?vue&type=script&lang=js"
export * from "./standardNumber.vue?vue&type=script&lang=js"
import style0 from "./standardNumber.vue?vue&type=style&index=0&id=fd8a816a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8a816a",
  null
  
)

export default component.exports